import Swiper from 'vendor.swiper';

class AnnouncementBarSlider extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('[data-announcement-wrapper]');
        this.swiper = null;
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 5;
    }

    connectedCallback() {
        requestAnimationFrame(() => this.initSwiper());
    }

    initSwiper() {
        if (!this.wrapper) {
            console.error('Announcement wrapper not found');
            return;
        }

        const slides = this.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            console.log('Only one slide found, slider not needed');
            return;
        }

        try {
            this.swiper = new Swiper(this.wrapper, {
                loop: true,
                speed: 500,
                autoplay: this.autoplay
                    ? {
                        delay: this.autoplayInterval * 1000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }
                    : false,
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },
            });
            console.log('Announcement bar slider initialized successfully');
        } catch (error) {
            console.error('Failed to initialize announcement bar slider:', error);
        }
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

if (!customElements.get('announcement-bar-slider')) {
    customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
